// pages/RecuperarContrasena.jsx
import React, { useState } from "react";
import { API_BASE_URL } from "../config";
import "../styles/Login.css"; // Reutiliza estilos existentes

const RecuperarContrasena = () => {
  const [email, setEmail] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [isToastVisible, setIsToastVisible] = useState(false);

  const showToast = (msg, type = "success") => {
    setToastMessage(msg);
    setToastType(type);
    setIsToastVisible(true);
    setTimeout(() => setIsToastVisible(false), 3000);
  };

  const handleSubmit = async () => {
    if (!email) {
      showToast("Debes ingresar tu correo electrónico", "error");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        showToast("Te hemos enviado un enlace de recuperación al correo", "success");
      } else {
        showToast(data.message || "No se pudo procesar la solicitud", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      showToast("No se pudo conectar al servidor", "error");
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Recuperar contraseña</h2>
      <input
        type="email"
        placeholder="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-input"
      />
      <button onClick={handleSubmit} className="form-button">
        Enviar enlace
      </button>

      {isToastVisible && (
        <div className={`toast toast-${toastType} show`}>{toastMessage}</div>
      )}
    </div>
  );
};

export default RecuperarContrasena;
